import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { DataGridView, useSub } from "@neumetric/blueprint-lib/components";
import { mitigatorActions, getSourcesByStatus } from "../../../store";

const PER_PAGE = process.env.REACT_APP_INC_PER_PAGE || 9;

const sourceColumns = [
  {
    dataIndex: "source_id",
    typeRepresentation: "LINK",
    title: "Source ID",
    width: "20%",
  },
  {
    dataIndex: "source",
    typeRepresentation: "TEXT",
    title: "Source",
    width: "20%",
    showTooltip: true,
  },
  {
    dataIndex: "description",
    typeRepresentation: "TEXT",
    title: "Source Description",
    width: "60%",
    showTooltip: true,
    semantics: {
      ellipsisFlag: true,
    },
  },
];

const getTab = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("tab") || "active";
};
const getPage = () => {
  let currentUrlParams = new URLSearchParams(window.location.search);
  return currentUrlParams.get("page") || 1;
};

export const MitigatorSourceTrackerScreen = () => {
  const [state, setState] = React.useState({
    activeSubmenu: getTab(),
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const _ref = React.useRef(null);
  const _filter = React.useRef({
    defaultPage: getPage(),
    pageNo: getPage(),
    search: "",
    pageSize: PER_PAGE,
  });
  const sourceList = useSelector(getSourcesByStatus.bind(null, state.activeSubmenu.toLowerCase())) || [];

  useEffect(() => {
    fetchSources();
  }, []);
  useSub("MITIGATOR_SUBMENU_TAB", (data) => {
    setState({
      activeSubmenu: data.tab,
    });
  });

  const dvgOptions = React.useMemo(() => {
    const options = { columns: [], className: "" };

    options.columns = sourceColumns;
    options.className = "w-674-px";

    return options;
  }, [state.activeSubmenu]);

  const fetchSources = () => {
    dispatch(mitigatorActions.fetchSources());
  };
  const handlePageChange = (pageNo) => {
    navigate(`${window.location.pathname}?page=${pageNo}`);
    _filter.current = { ..._filter.current, pageNo };
    fetchSources();
  };

  return (
    <div className={`col w-100 h-100 overflow-hide ${dvgOptions.className}`} ref={_ref}>
      <DataGridView
        columns={dvgOptions.columns}
        dataSource={sourceList.map((src) => ({
          source_id: src.source_id || src.id,
          source: src.name,
          description: src.description,
          id: src.id,
        }))}
        pagination={{
          pageSize: 9,
          totalCount: sourceList.length,
          recentFlag: false,
          defaultPage: _filter.current.defaultPage,
          onPageChange: handlePageChange,
        }}
        getCellSemantics={(column, record) => {
          if (column.dataIndex === "source_id") {
            return {
              onLinkClick: () => {
                const p = new URLSearchParams(window.location.search);
                p.set("tab", (state.activeSubmenu || "active").toLowerCase());
                p.set("open", "view-panel");
                p.set("id", record.id);
                p.set("_ts", Date.now());

                navigate(`${window.location.pathname}?${p.toString()}`);
              },
            };
          }
          return {};
        }}
        EmptyComponent={
          <span className="ff-exo2 f16 c777">There are no {state.activeSubmenu.toLowerCase()} sources right now!</span>
        }
      />
    </div>
  );
};
